import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import Loader from "../../../utils/Loader";
import { fill_action } from "../../../actions/common_action/fillList_action";
import {
  get_userList_action,
  deleteUser_action,
} from "../../../actions/adminModule_action/user_action";
import { responseError, roleActionId } from "../../../utils/constants";
import Modal from "react-bootstrap/Modal";
import { ToastContainer, toast } from "react-toastify";
import Pagination from "../../../utils/pagination";
import Button from "react-bootstrap/Button";
import Header from "../../../common_components/Header";
import Footer from "../../../common_components/Footer";
import MobileHeader from "../../../common_components/mobileHeader";
class userList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      userList: [],
      role_id: "", designation: '',
      roleList: [],
      userName: "",
      userEmail: "",
      is_active: "Active",
      StatusName: "",
      user_id: "",
      show: false,
      currentPage: 1,
      isAccordionExpanded: false,
      roleName: "", Phone: ""
    };

    this.userAdd = this.userAdd.bind(this);
    this.userUpdate = this.userUpdate.bind(this);
    this.updateItem = this.updateItem.bind(this);
  }

  componentDidMount() {
    if (JSON.parse(sessionStorage.getItem("AwardsUserLoginData")) == null) {
      setTimeout(() => {
        this.props.navigate("/login");
      }, 500);
    }

    setTimeout(() => {
      {
        (sessionStorage.getItem("role_id") == 2 || sessionStorage.getItem("role_id") == 4) ? (
          this.props.navigate("/login")
        ) : <></>
      }
    }, 10);
    this.getFillList(roleActionId, sessionStorage.getItem("user_id"), "", "");
    setTimeout(() => {
      this.getUserList(0);
    }, 200);
  }

  getFillList(value, user_id, keyword, keyvalue) {
    this.setState({ isLoading: true });
    this.props
      .fill_action(
        value,
        user_id == "" || user_id == null ? null : user_id,
        keyword != "" ? keyword : null,
        keyvalue != "" ? keyvalue : null
      )
      .then((data) => {
        if (data.error != 1) {
          if (value == roleActionId) {
            this.setState({ roleList: data.data, isLoading: false });
          }
        } else {
          responseError(data);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  handleDelete(id) {
    this.setState({ isLoading: true });
    this.props
      .deleteUser_action(id)
      .then((data) => {
        if (data.error != 1) {
          this.props.navigate("/user");
          this.getUserList(0);
          this.setState({ isLoading: false, show: false });
          toast.success("Deleted SuccessFully!", {
            position: "top-center",
            theme: "colored",
            autoClose: 3000,
            hideProgressBar: true,
          });
        } else {
          responseError(data);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }
  getUserList(isExport) {
    const { userName, userEmail, designation, Phone, role_id, is_active } = this.state;
    this.setState({ isLoading: true });

    this.props
      .get_userList_action(
        userName !== "" && userName !== null ? userName : null,
        userEmail !== "" && userEmail !== null ? userEmail : null,
        Phone !== "" && Phone !== null ? Phone : null,
        designation !== "" && designation !== null ? designation : null,
        role_id !== "" && role_id !== null ? role_id : null,
        is_active === 'Active' ? 1 : is_active === 'suspend' ? 2 : 0
      )
      .then((data) => {
        if (data.error !== 1) {
          this.setState({ userList: data.data });
          this.setState({ isLoading: false });

          if (isExport === 1) {
            const headers = this.prepareExportHeaders(data.data);
            const filteredData = this.prepareExportData(data.data, headers);
            this.exportToExcel(filteredData, headers);
          }
        } else {
          responseError(data);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  prepareExportHeaders(data) {
    const headers = Object.keys(data[0] || {});
    return headers.map((header) => {
      if (header === 'is_active') return 'Status';
      if (header === 'user_id') return '';
      return header.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
    }).filter((header) => header !== '');
  }

  prepareExportData(data, headers) {
    return data.map((user) => {
      const { user_id, ...userData } = user;
      let mappedData = { ...userData };
      mappedData.Status = user.is_active === 1 ? 'Active' : user.is_active === 2 ? 'Suspended' : 'Inactive';
      return mappedData;
    });
  }

  exportToExcel(data, headers) {
    const XLSX = require('xlsx');

    const colWidths = headers.map((header) => {
      const maxLength = data.reduce((max, row) => {
        const value = row[header.toLowerCase().replace(/ /g, '_')] || '';
        return Math.max(max, value.length);
      }, header.length);
      return { wpx: Math.min(maxLength * 10, 200) };
    });

    const transformedData = data.map((item) => {
      const mappedItem = {};
      headers.forEach((header) => {
        if (header === 'Status') {
          mappedItem[header] = item.Status;
        } else {
          mappedItem[header] = item[header.toLowerCase().replace(/ /g, '_')] || '';
        }
      });
      return mappedItem;
    });
    const ws = XLSX.utils.json_to_sheet(transformedData, { header: headers });
    ws['!cols'] = colWidths;
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'User List');
    XLSX.writeFile(wb, 'Award_User_List.xlsx');
  }

  clearValue() {
    this.setState({
      userName: "",
      userEmail: "",
      Phone: "",
      role_id: "",
      designation: "",
      is_active: 'Active'
    });

    setTimeout(() => {
      this.getUserList(0);
    }, 200);
  }

  updateItem(item) {
    this.setState({ currentPage: item });
  }

  toggleModal(id) {
    const confirmed = window.confirm(
      "Do you really want to delete this record?"
    );
    if (confirmed) {
      this.handleDelete(id);
    }
  }

  userAdd() {
    this.props.navigate("/userAU", { state: { userAdd: true } });
  }

  userUpdate(user_id) {
    this.props.navigate("/userAU", {
      state: { userUpdate: true, user_id: user_id },
    });
  }

  record(userList) {
    // const { userList } =this.state
    return (
      <table class="table table-bordered" id="dashboard-table">
        <thead>
          <tr>
            <th>User Name</th>
            <th>Email Address</th>
            <th>Contact no</th>
            <th>Designation</th>
            <th>Role Name</th>
            <th>Status</th>
            <th class="text-right" style={{ width: '5%' }}>
            </th>
          </tr>
        </thead>
        {userList != "" && userList != null ? (
          userList.map((data, i) => (
            <tbody id="myTable">
              <tr>
                <td>{data.name}</td>
                <td>{data.email_address}</td>
                <td>
                  {data.contact_no != null && data.contact_no != "" ? data.contact_no : "-"}
                </td>
                <td>
                  {data.designation != null && data.designation != ""
                    ? data.designation
                    : "-"}
                </td>
                <td>{data.role_name}</td>
                <td>{data.is_active == 1 ? "Active" : data.is_active == 2 ? "suspend" : "Inactive"}</td>
                <td class="text-right">
                  <a
                    title="Edit"
                    class="btn btn-sm"
                    onClick={() => this.userUpdate(data.user_id)}
                  >
                    <i class="fa fa-pencil-square-o text-primary"></i>
                  </a>
                  {data.is_active == 1 ? (
                    <a
                      title="Delete"
                      class="btn btn-sm delete_record ml-2 text-danger"
                      onClick={() => this.toggleModal(data.user_id)}
                    >
                      <i class="ri-delete-bin-line"></i>
                    </a>
                  ) : (
                    <></>
                  )}
                </td>
              </tr>
            </tbody>
          ))
        ) : (
          <tr>
            <td colSpan={7} className="text-center">
              Record not found
            </td>
          </tr>
        )}
      </table>
    );
  }

  role(e) {
    var newList = [];
    newList.push(e.value.split(","));
    setTimeout(() => {
      this.setState({
        role_id: newList[0],
        roleName: newList[0][1],
      });
    }, 200);
  }

  status(e) {
    const { StatusList } = this.state;

    this.setState({ is_active: e.target.value });
    if (e.target.value == "Select") {
      this.setState({ StatusName: "Select" });
    } else {
      StatusList.filter((item) => {
        if (e.target.value == item["ID"]) {
          this.setState({ StatusName: item["Status"] });
        }
      });
    }
  }

  render() {
    const {
      isLoading,
      userList,
      roleList,
      userName,
      userEmail, Phone,
      designation,
      show,
      currentPage,
      isAccordionExpanded,
      roleName, role_id, is_active
    } = this.state;

    const recordsPerPage = 10;
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    // Records to be displayed on the current page
    const currentRecords = userList?.slice(
      indexOfFirstRecord,
      indexOfLastRecord
    );
    const nPages = Math.ceil(userList?.length / recordsPerPage);

    return (
      <>
        {isLoading ? (
          <Loader></Loader>
        ) : (
          <>
            <main id="main">
              {/* <Header data={[22]} /> */}

              <div className="website-view">
                <Header data={[8]} />
              </div>
              <div className="mobile-view">
                <MobileHeader data={[8]} />
              </div>

              <section class='header_margin_top'>
                <div class="container-fluid">
                  <div class="page-header">
                    <h2 class="mb-1 dashboard-tit  py-0 blog-name">List of User</h2>
                    <div>
                      <button className="btn btn-outline-success mr-2" onClick={() => this.getUserList(1)}> Export </button>
                      <button className="btn btn-outline-primary" onClick={() => this.userAdd()}> Add </button>
                    </div>
                  </div>
                  <div class="search_accordion search_card">
                    <div class="panel-group" id="accordion">
                      <div class="panel panel-default">
                        <div
                          className="panel-heading accordion-toggle collapsed"
                          data-toggle="collapse"
                          data-parent="#accordion"
                          data-target="#collapseOne"
                          aria-expanded={isAccordionExpanded}
                          onClick={() =>
                            this.setState({
                              isAccordionExpanded: !isAccordionExpanded,
                            })
                          }
                        >
                          <h4 class="panel-title">Search</h4>

                          <div class="searched_items">
                            {userName ? <>
                              <h5>
                                Name :<span>{userName}</span>
                              </h5>
                            </> : <></>}
                            {userEmail ? <>
                              <h5>
                                Email :<span>{userEmail}</span>
                              </h5>
                            </> : <></>}
                            {Phone ? <>
                              <h5>
                                Contact :<span>{Phone}</span>
                              </h5>
                            </> : <></>}
                            {roleName ? <>
                              <h5>
                                Role :{" "}
                                <span>
                                  {role_id != "" ? roleName : null}
                                </span>
                              </h5>
                            </> : <></>}
                            {designation ? <>
                              <h5 >
                                Designation :{" "}
                                <span>
                                  {designation != "" ? designation : null}
                                </span>
                              </h5>
                            </> : <></>}
                            {is_active ? <>
                              <h5 >
                                Status :{" "}
                                <span>
                                  {is_active != "" ? is_active : null}
                                </span>
                              </h5>
                            </> : <></>}
                          </div>
                        </div>
                        <div
                          id="collapseOne"
                          className={`panel-collapse collapse ${isAccordionExpanded ? "show" : ""
                            }`}
                        >
                          <div class="panel-body p-2">
                            <div class="row mr_0">
                              <div class="col-md-2">
                                <div class="form-group">
                                  <label>Name</label>
                                  <input
                                    type="text"
                                    class="form-control search_form_control"
                                    placeholder="Enter Name"
                                    value={userName}
                                    onChange={(e) =>
                                      this.setState({
                                        userName: e.target.value,
                                      })
                                    }
                                  />
                                </div>
                              </div>
                              <div class="col-md-2">
                                <div class="form-group">
                                  <label>Email</label>
                                  <input
                                    type="text"
                                    class="form-control search_form_control"
                                    placeholder="Enter Email"
                                    value={userEmail}
                                    onChange={(e) =>
                                      this.setState({
                                        userEmail: e.target.value,
                                      })
                                    }
                                  />
                                </div>
                              </div>
                              <div class="col-md-2">
                                <div class="form-group">
                                  <label>Contact</label>
                                  <input
                                    type="text"
                                    class="form-control search_form_control"
                                    placeholder="Enter contact"
                                    value={Phone}
                                    onChange={(e) =>
                                      this.setState({
                                        Phone: e.target.value,
                                      })
                                    }
                                  />
                                </div>
                              </div>
                              <div class="col-md-2">
                                <div class="form-group">
                                  <label>Role</label>
                                  <select
                                    className="form-select"
                                    value={role_id}
                                    onChange={(e) => {
                                      const selectedRound = roleList.find((item) => item.role_id === parseInt(e.target.value, 10));
                                      this.setState({
                                        role_id: selectedRound?.role_id,
                                        roleName: selectedRound?.roleName,
                                      })
                                    }}>
                                    <option value="">Select</option>
                                    {roleList.length > 0 &&
                                      roleList.map((item) => (
                                        <option key={item.role_id} value={item.role_id}>
                                          {item.roleName}
                                        </option>
                                      ))}
                                  </select>
                                </div>
                              </div>
                              <div class="col-md-2">
                                <div class="form-group">
                                  <label>Designation</label>
                                  <input
                                    type="text"
                                    class="form-control search_form_control"
                                    placeholder="Enter contact"
                                    value={designation}
                                    onChange={(e) =>
                                      this.setState({
                                        designation: e.target.value,
                                      })
                                    }
                                  />
                                </div>
                              </div>
                              <div className="col-md-2">
                                <div className="form-group">
                                  <label>Status</label>
                                  <select
                                    className="form-select"
                                    value={is_active}
                                    onChange={(e) => {
                                      this.setState({
                                        is_active: e.target.value,
                                      });
                                    }}
                                  >
                                    <option key='Active' value="Active">Active</option>
                                    <option key='InActive' value="InActive">In-Active</option>
                                    <option key='suspend' value="suspend">Suspend</option>
                                  </select>
                                </div>
                              </div>
                              <div class="col-md-2">
                                <label>&nbsp;</label>
                                <a class="btn btn-outline-primary search_btn" onClick={() => this.getUserList(0)}>Search</a> &nbsp;
                                <a class="btn btn-outline-danger clr_btn" onClick={() => this.clearValue()}>Clear</a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="custom_table d-flex">
                    <div class="hack1">
                      <div class="hack2">
                        {this.record(currentRecords)}
                        {userList?.length > 0 ? (
                          <Pagination
                            nPages={nPages}
                            currentPage={currentPage}
                            setCurrentPage={this.updateItem}
                          />
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </main>
            <Footer />
          </>
        )}

        <ToastContainer />

        <Modal show={show} size="md">
          <Modal.Header>
            <Modal.Title>Confirm Delete</Modal.Title>
            <span
              onClick={() => this.setState({ show: !show })}
              style={{ cursor: "pointer", fontWeight: "800" }}
            >
              X
            </span>
          </Modal.Header>
          <Modal.Body>
            <div className="col-md-12">
              <h3 className="pop_label">
                Do you really want to delete this record?
              </h3>
            </div>
          </Modal.Body>

          <Modal.Footer style={{ padding: "5px 12px" }}>
            <Button variant="success" onClick={() => this.handleDelete()}>
              Yes
            </Button>
            <Button
              variant="secondary"
              onClick={() => this.setState({ show: !show })}
            >
              No
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

export default withRouter(
  connect(null, { fill_action, get_userList_action, deleteUser_action })(
    userList
  )
);
